import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  FeatureList,
  TypeShowcase
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

const SpeedCameraBooth = () => {
  
  const typeShowcase = [
    {
        title: 'Type A | 캐릭터형',
        mainImage: '/images/products/traffic-safety/speed-camera-booth3.png',
        shots: [
        {
            image: '/images/products/traffic-safety/speed-camera-booth6.jpg',
            caption: '야간 작동 모습 1 (호남선 102.6K 순천방향)',
        },
        {
            image: '/images/products/traffic-safety/speed-camera-booth7.jpg',
            caption: '야간 작동 모습 2 (호남선 102.6K 순천방향)',
        },
        ],
    },
    {
        // code: 'B',
        title: 'Type B | 속도표시형',
        mainImage: '/images/products/traffic-safety/speed-camera-booth4.png',
        shots: [
        {
            image: '/images/products/traffic-safety/speed-camera-booth9.jpg',
            caption: '야간 작동 모습 1 (호남선 106.9K 순천방향)',
        },
        {
            image: '/images/products/traffic-safety/speed-camera-booth10.jpg',
            caption: '야간 작동 모습 2 (호남선 106.9K 순천방향)',
        },
        ],
    },
    ];

  const features = [
    {
      title: '캐릭터형 과속단속 카메라 부스',
      subtitle: '시각적 효과를 극대화한 디자인으로 운전자의 주의를 자연스럽게 끌어내는 모델',
      bullets: [
      {
        label: (
          <><strong>주·야간 뛰어난 시인성 확보</strong></>
        ),
        detail: (
          <>고휘도 LED와 고대비 색상 설계를 적용해 낮과 밤, 악천후에도 높은 인지도를 제공함</>
        ),
      },
      {
        label: (
          <><strong>친근하고 직관적인 캐릭터 형태</strong></>
        ),
        detail: (
          <>지나치게 위압적이지 않으면서도 경각심을 유발하는 디자인으로 감속 유도 효과가 증대됨</>
        ),
      },
      {
        label: (
          <><strong>관광지·도심지·교량 등 다양한 환경에 적합</strong></>
        ),
        detail: (
          <>시각적 포인트를 제공해 도로 미관 개선 효과도 기대할 수 있음</>
        ),
      },
      ]
    },
    {
      title: '속도표시형 과속단속 카메라 부스',
      subtitle: '운전자가 자신의 현재 주행속도를 즉각 확인하고 감속하도록 유도하는 기능 중심 모델',
      bullets: [
      {
        label: (
          <><strong>실시간 속도 표시 기능</strong></>
        ),
        detail: (
          <>차량 감지 센서와 연동된 LED 디스플레이로 운전자의 현재 속도를 즉시 표기해 과속을 실질적으로 억제함</>
        ),
      },
      {
        label: (
          <><strong>높은 경고 효율</strong></>
        ),
        detail: (
          <>허용 속도 초과 시 색상 변경·점멸 등 시각적 경고로 즉각적인 행동 변화를 유도함</>
        ),
      },
      {
        label: (
          <><strong>주·야간 최적의 가독성 확보</strong></>
        ),
        detail: (
          <>다양한 밝기 환경에서도 선명하게 인식되도록 자동 밝기 조절 기능을 적용함</>
        ),
      },
      ]
    },
  ];


  

  return (
    <>
      <HeroSection
        title={`과속 단속 카메라 부스`}
        subtitle={`단속 외 시간대에도 \n높은 시인성과 안전 효과를 제공합니다`}
        backgroundImage="/images/products/traffic-safety/speed-camera-booth9.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '과속 단속 카메라 부스' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`차세대 교통안전 솔루션`}
        title={`과속 단속 카메라 부스`}
        description={
          <>
            고속도로 과속단속 카메라 부스의 활용도를 높이기 위해 개발된 시스템으로써, {' '}
            단속 이외의 시간대에도 주야간 시인성이 뛰어난 캐리터형과 운전자 속도를 자각시키는 속도표시형 2가지 타입의 제품입니다.
            <br />
            <br />
            단속 외 시간대에도 높은 시인성과 안전 효과를 제공하는 차세대 교통안전 솔루션으로, {' '}
            운전자가 자연스럽게 속도를 인지하고 감속할 수 있도록 유도하며, 사고 예방과 교통 흐름 안정화에 크게 기여합니다.
          </>
        }
        images={[
          '/images/products/traffic-safety/speed-camera-booth5.png',
          '/images/products/traffic-safety/speed-camera-booth8.png',
        ]}
      />

      <SectionDivider />

      <InfoSection title="제품 유형">
        <TypeShowcase types={typeShowcase} />
      </InfoSection>


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="traffic-safety"
        currentPath="/products/traffic-safety/speed-camera-booth"
        listPath="/products/traffic-safety"
      />


      <CTASection />
    </>
  );
};

export default SpeedCameraBooth;
